const hi = {
  lang: {
    change: "भाषा बदलें",
    english: "English - EN",
    hindi: "हिन्दी - HI",
    code: { en: "EN", hi: "HI" },
  },
  nav: {
    products: "उत्पाद",
    coverageCalculators: "कवरेज कैलकुलेटर",
    adhesiveCoverage: "एडहेसिव कवरेज",
    groutCoverage: "ग्राउट कवरेज",
    groutVisualizer: "ग्राउट विज़ुअलाइज़र",
    about: "हमारे बारे में",
    careers: "करियर",
    journal: "जर्नल",
    contact: "संपर्क",
    getQuote: "कोटेशन लें",
    catalogue: "कैटलॉग",
    viewAllProducts: "सभी उत्पाद देखें",
    openMenu: "मेनू खोलें",
    closeMenu: "मेनू बंद करें",
  },
  footer: {
    letsBuild: "आइए साथ मिलकर बनाएँ",
    certifiedQuality: "प्रमाणित गुणवत्ता",
    modernIndia: "आधुनिक भारत के लिए।",
    requestQuote: "कोटेशन का अनुरोध करें",
    isoLine: "ISO 9001:2015 · ISI मार्क",
    blurb: "प्रीमियम कच्चे माल से इंजीनियर किए गए कंस्ट्रक्शन केमिकल्स। हर बैच में प्रमाणित गुणवत्ता, नवाचार और दीर्घकालिक प्रदर्शन।",
    products: "उत्पाद",
    tools: "टूल्स",
    company: "कंपनी",
    tileAdhesives: "टाइल एडहेसिव",
    grouts: "ग्राउट्स",
    admixtures: "एडमिक्स्चर",
    blockAdhesive: "ब्लॉक एडहेसिव",
    plasterFlooring: "प्लास्टर और फ्लोरिंग",
    adhesiveCalculator: "एडहेसिव कैलकुलेटर",
    groutCalculator: "ग्राउट कैलकुलेटर",
    groutVisualiser: "ग्राउट विज़ुअलाइज़र",
    journal: "जर्नल",
    aboutUs: "हमारे बारे में",
    careers: "करियर",
    contact: "संपर्क",
    getQuote: "कोटेशन लें",
    rights: "Ashlar Buildchem. सर्वाधिकार सुरक्षित।",
    tagline: "आधुनिक भारत के लिए कंस्ट्रक्शन केमिकल्स",
  },
  home: {
    eyebrow: "कंस्ट्रक्शन केमिकल्स · स्थापना 2020 · भारत",
    heroLine1: "कंस्ट्रक्शन",
    heroLine2a: "केमिकल्स",
    heroLine2b: " के लिए",
    heroLine3: "आधुनिक भारत",
    heroBody: "प्रमाणित गुणवत्ता, उन्नत केमिस्ट्री और दीर्घकालिक प्रदर्शन के साथ इंजीनियर किए गए टाइल एडहेसिव, ग्राउट्स और बिल्डिंग सॉल्यूशंस।",
    exploreProducts: "उत्पाद देखें",
    coverageCalculators: "कवरेज कैलकुलेटर",
    manifesto: "हमारा दृष्टिकोण",
    manifestoTitle: "हम समझौते नहीं करते। हम केमिस्ट्री बनाते हैं।",
    m1Title: "नींव",
    m1Body: "2020 में स्थापित, Ashlar Buildchem भारत की सबसे तेज़ी से बढ़ती कंस्ट्रक्शन केमिकल कंपनियों में से एक बन गई है — प्रमाणित गुणवत्ता और निरंतर इंजीनियरिंग पर आधारित।",
    m2Title: "केमिस्ट्री",
    m2Body: "हमारे फॉर्मूलेशन प्रीमियम कच्चे माल और उन्नत केमिस्ट्री से इंजीनियर किए गए हैं — बॉन्ड स्ट्रेंथ, लचीलापन और टिकाऊपन जो सामान्य से बेहतर है।",
    m3Title: "मानक",
    m3Body: "ISO 9001:2015 प्रमाणित प्रक्रियाएँ और ISI-मार्क उत्पाद, अत्याधुनिक टेस्टिंग सुविधा में सत्यापित। हर बैच में सिद्ध उत्कृष्टता।",
    founded: "स्थापना",
    products: "उत्पाद",
    rawMaterials: "कच्चा माल",
    catalogue: "कैटलॉग",
    systemTitle: "हर सतह के लिए एक सिस्टम।",
    allProducts: "सभी उत्पाद",
    estimator: "अनुमानक",
    adhesiveCoverage: "एडहेसिव कवरेज",
    adhesiveBody: "अपने क्षेत्र और ट्रॉवेल नॉच साइज़ से टाइल एडहेसिव बैग का अनुमान लगाएँ।",
    groutCoverage: "ग्राउट कवरेज",
    groutBody: "टाइल ज्यामिति और जॉइंट चौड़ाई से ग्राउट खपत की गणना करें।",
    groutVisualiser: "ग्राउट विज़ुअलाइज़र",
    visualiserBody: "खरीदने से पहले टाइल और ग्राउट रंग संयोजन लाइव देखें।",
    openCalculator: "कैलकुलेटर खोलें",
    signature: "सिग्नेचर रेंज",
    builtToBond: "बंधन के लिए बना।",
    readyTitle: "Ashlar निर्दिष्ट करने के लिए तैयार?",
    talkTeam: "हमारी टीम से बात करें",
    marqueeAdvanced: "उन्नत केमिस्ट्री",
    marqueeCertified: "प्रमाणित गुणवत्ता",
    architectureAlt: "आधुनिक वास्तुकला",
  },
  about: {
    eyebrow: "2020 से · जयपुर, भारत",
    h1a: "सशक्त बनाते हैं",
    h1b: "निर्माण को",
    h1c: "निश्चितता से।",
    intro: "2020 में स्थापित, Ashlar Buildchem भारत की सबसे तेज़ी से बढ़ती कंस्ट्रक्शन केमिकल कंपनियों में से एक है। हमारा उद्देश्य सरल है: प्रमाणित गुणवत्ता, नवाचार और दीर्घकालिक प्रदर्शन के साथ निर्माण को सशक्त बनाना। ISO-प्रमाणित प्रक्रियाओं, ISI-मार्क उत्पादों और अत्याधुनिक टेस्टिंग सुविधा के साथ हम हर बैच में उत्कृष्टता सुनिश्चित करते हैं।",
    standFor: "हम किन सिद्धांतों पर खड़े हैं",
    principlesTitle: "चार सिद्धांत। कोई शॉर्टकट नहीं।",
    journey: "यात्रा",
    journeyTitle: "पाँच वर्ष, एक मानक।",
    partner: "Ashlar के साथ साझेदारी करें।",
    getInTouch: "संपर्क करें",
    v1Title: "प्रमाणित गुणवत्ता",
    v1Body: "हर बैच में ISO 9001:2015 और ISI मानकों का पालन।",
    v2Title: "इंजीनियर्ड केमिस्ट्री",
    v2Body: "वास्तविक, मापने योग्य प्रदर्शन के लिए प्रीमियम कच्चा माल।",
    v3Title: "दीर्घकालिक प्रदर्शन",
    v3Body: "केवल लगाने के लिए नहीं — लंबे समय तक टिकने के लिए डिज़ाइन किए गए उत्पाद।",
    v4Title: "भारत के लिए बना",
    v4Body: "भारतीय जलवायु, सबस्ट्रेट और कारीगरी के लिए फॉर्मूलेटेड।",
    t2020Title: "शुरुआत",
    t2020Body: "भारतीय कंस्ट्रक्शन केमिकल्स का मानक बढ़ाने के मिशन के साथ जयपुर में Ashlar Buildchem की स्थापना।",
    t2021Title: "उन्नत केमिस्ट्री",
    t2021Body: "बेहतर बॉन्ड प्रदर्शन के लिए प्रीमियम कच्चे माल से फॉर्मूलेशन अपग्रेड।",
    t2022Title: "प्रमाणित",
    t2022Body: "ISO 9001:2015 प्रक्रियाएँ और ISI-मार्क उत्पाद, समर्पित इन-हाउस टेस्टिंग सुविधा से सत्यापित।",
    t2025Title: "राष्ट्रव्यापी",
    t2025Body: "टाइलिंग, ग्राउटिंग, ब्लॉक और सतहों में पूर्ण सिस्टम के साथ भारत के सबसे तेज़ी से बढ़ते ब्रांडों में से एक।",
    labAlt: "प्रयोगशाला परीक्षण",
    siteAlt: "निर्माण स्थल",
  },
  contact: {
    eyebrow: "Ashlar Connect",
    h1a: "आइए",
    h1b: "बात करें।",
    intro: "कोटेशन का अनुरोध करें, तकनीकी मार्गदर्शन माँगें या डिस्ट्रीब्यूटर बनें। फ़ॉर्म भरें और हमारे विशेषज्ञ जवाब देंगे।",
    fullName: "पूरा नाम *",
    namePlaceholder: "आपका नाम",
    email: "ईमेल *",
    emailPlaceholder: "you@company.com",
    phone: "फ़ोन *",
    company: "कंपनी",
    optional: "वैकल्पिक",
    subject: "विषय *",
    subjectPlaceholder: "कोट / डिस्ट्रीब्यूटर / तकनीकी",
    message: "संदेश *",
    messagePlaceholder: "अपने प्रोजेक्ट के बारे में बताएँ…",
    send: "संदेश भेजें",
    sending: "भेजा जा रहा है…",
    tollFree: "टोल-फ्री",
    emailLabel: "ईमेल",
    office: "पंजीकृत कार्यालय",
    badges: "ISO 9001:2015 · ISI मार्क · प्रमाणित गुणवत्ता",
    errRequired: "कृपया सभी आवश्यक फ़ील्ड भरें।",
    errName: "पूरे नाम में केवल अक्षर और स्पेस हो सकते हैं।",
    errPhone: "मान्य 10 अंकों का भारतीय मोबाइल नंबर दर्ज करें।",
    success: "धन्यवाद — हमारी टीम शीघ्र संपर्क करेगी।",
    errGeneric: "कुछ गलत हुआ। कृपया फिर कोशिश करें या 1800 309 0808 पर कॉल करें।",
  },
  products: {
    catalogue: "कैटलॉग",
    title: "उत्पाद",
    intro: "टाइल एडहेसिव, ग्राउट्स, एडमिक्स्चर और बिल्डिंग सॉल्यूशंस का पूरा सिस्टम — उन्नत फॉर्मूलेशन केमिस्ट्री से इंजीनियर।",
    filter: "फ़िल्टर",
    allProducts: "सभी उत्पाद",
    product: "उत्पाद",
    productsCount: "उत्पाद",
    explore: "देखें",
  },
  productDetail: {
    loading: "लोड हो रहा है…",
    notFound: "उत्पाद नहीं मिला",
    back: "← उत्पादों पर वापस",
    catalogue: "कैटलॉग",
    requestQuote: "कोटेशन का अनुरोध करें",
    coverageCalc: "कवरेज कैलकुलेटर",
    overview: "अवलोकन",
    keyFeatures: "मुख्य विशेषताएँ",
    technicalData: "तकनीकी डेटा",
    classLabel: "क्लास",
    enquire: "पूछताछ / कोटेशन लें",
    calculate: "गणना करें",
    allArrow: "सभी →",
    features: "विशेषताएँ",
    applications: "उपयोग",
    substrates: "सबस्ट्रेट",
    packaging: "पैकेजिंग",
    coverage: "कवरेज",
    colour: "रंग",
    classification: "वर्गीकरण",
    related: "संबंधित उत्पाद",
  },
  blog: {
    eyebrow: "फ़ील्ड नोट्स और तकनीकी गाइड",
    title: "जर्नल",
    readArticle: "लेख पढ़ें",
    loading: "लोड हो रहा है…",
    notFound: "लेख नहीं मिला",
    back: "← जर्नल पर वापस",
    journal: "जर्नल",
    similarEyebrow: "और जानें",
    similarTitle: "संबंधित लेख",
    quickAnswer: "क्विक उत्तर (TL;DR)",
    quickAnswerSubtitle: "मुख्य निष्कर्ष एक नज़र में",
    faqsTitle: "अक्सर पूछे जाने वाले प्रश्न",
    faqsSubtitle: "हमारे तकनीकी विशेषज्ञों से सीधे उत्तर।",
    talkSpecialist: "विशेषज्ञ से बात करें",
    needGuidance: "मार्गदर्शन चाहिए?",
    consultSpecialists: "तकनीकी विशेषज्ञों से संपर्क करें",
    guidanceDesc: "Ashlar इंजीनियरों से प्रोजेक्ट-विशिष्ट सिफारिशें, विनिर्देश और ऑन-साइट मार्गदर्शन प्राप्त करें।",
    requestAdvice: "तकनीकी सलाह का अनुरोध करें",
    tollFreeSupport: "टोल-फ्री सहायता",
  },
  calculators: {
    eyebrow: "अनुमानक और विज़ुअलाइज़र",
    h1a: "अनुमान लगाएँ और",
    h1b: "देखें",
    intro: "अनुमान लगाएँ कि आपके प्रोजेक्ट में कितना एडहेसिव या ग्राउट चाहिए, फिर ऑर्डर से पहले टाइल और ग्राउट रंग संयोजन लाइव देखें।",
    adhesiveTitle: "एडहेसिव कवरेज कैलकुलेटर",
    groutTitle: "ग्राउट कवरेज कैलकुलेटर",
    totalArea: "टाइल करने का कुल क्षेत्र",
    bedThickness: "बेड मोटाई (ट्रॉवेल नॉच)",
    bedHint: "बड़ी टाइल्स और असमान सतहों के लिए मोटा बेड चाहिए।",
    bagSize: "बैग साइज़",
    waste: "बर्बादी और स्पिलेज के लिए 5% जोड़ें",
    estimated: "अनुमानित आवश्यकता",
    bagsRequired: "आवश्यक बैग",
    bags: "बैग",
    totalAdhesive: "कुल एडहेसिव",
    consumption: "खपत",
    area: "क्षेत्र",
    adhesiveDisclaimer: "अनुमान सांकेतिक हैं। वास्तविक खपत सबस्ट्रेट समतलता, टाइल साइज़ और लगाने की तकनीक पर निर्भर करती है। प्रोजेक्ट स्पेसिफिकेशन के लिए Ashlar Connect से संपर्क करें।",
    viewTileAdhesives: "टाइल एडहेसिव देखें",
    groutType: "ग्राउट प्रकार",
    tileLength: "टाइल लंबाई (मिमी)",
    tileWidth: "टाइल चौड़ाई (मिमी)",
    tileThickness: "टाइल मोटाई (मिमी)",
    jointWidth: "जॉइंट चौड़ाई (मिमी)",
    totalTiledArea: "कुल टाइल किया क्षेत्र",
    reset: "रीसेट",
    totalGrout: "कुल ग्राउट",
    packsRequired: "आवश्यक पैक",
    groutDisclaimer: "ग्राउट खपत = ((L + W) / (L × W)) × जॉइंट चौड़ाई × टाइल मोटाई × घनत्व। अनुमान सांकेतिक हैं; साइट स्थितियों के लिए ऊपर गोल करें।",
    viewGrouts: "ग्राउट्स देखें",
    sqft: "वर्ग फुट",
    sqm: "वर्ग मीटर",
    bag20: "20 किग्रा बैग (टाइल एडहेसिव)",
    bag40: "40 किग्रा बैग (ब्लॉक एडहेसिव)",
    bed3: "3 मिमी बेड · 6 मिमी नॉच (छोटी टाइल्स)",
    bed4: "4 मिमी बेड · 8 मिमी नॉच (मध्यम)",
    bed5: "5 मिमी बेड · 10 मिमी नॉच (बड़ी)",
    bed6: "6 मिमी बेड · 12 मिमी नॉच (भारी / स्टोन)",
    cementitious: "सीमेंटिशियस ग्राउट (ATG01) — 1 किग्रा पैक",
    epoxy: "एपॉक्सी ग्राउट (AEG01) — 5 किग्रा / 1 किग्रा किट",
  },
  visualizerPage: {
    eyebrow: "अनुमानक और विज़ुअलाइज़र",
    h1a: "ग्राउट",
    h1b: "विज़ुअलाइज़र",
    intro: "ऑर्डर से पहले टाइल और ग्राउट रंग संयोजन लाइव देखें।",
  },
  visualizer: {
    tileLayout: "टाइल लेआउट",
    straight: "सीधा",
    brick: "ब्रिक",
    subway: "सबवे",
    largeFormat: "लार्ज फॉर्मेट",
    tileColour: "टाइल रंग",
    selected: "चयनित",
    groutColour: "ग्राउट रंग",
    jointWidth: "जॉइंट चौड़ाई",
    tileSize: "टाइल साइज़",
    widthFt: "चौड़ाई (फुट)",
    heightFt: "ऊँचाई (फुट)",
    custom: "कस्टम",
    reset: "रीसेट",
    livePreview: "लाइव प्रिव्यू",
    tile: "टाइल",
    grout: "ग्राउट",
    joint: "जॉइंट",
    disclaimer: "दिखाए गए रंग केवल स्क्रीन पर विज़ुअलाइज़ेशन के लिए अनुमानित हैं और वास्तविक उत्पाद से भिन्न हो सकते हैं। स्पार्कल फिनिश Ashlar Epoxy Sparkles (AES01) से प्राप्त होते हैं।",
    shopGrouts: "ग्राउट्स खरीदें",
    sparkleNote: " · एपॉक्सी स्पार्कल (AES01)",
    white: "सफ़ेद",
    ivory: "आइवरी",
    beige: "बेज",
    grey: "ग्रे",
    graphite: "ग्रेफाइट",
    black: "काला",
    marble: "मार्बल",
    brightWhite: "ब्राइट वाइट",
    silverGrey: "सिल्वर ग्रे",
    cementGrey: "सीमेंट ग्रे",
    charcoal: "चारकोल",
    jetBlack: "जेट ब्लैक",
    chocolate: "चॉकलेट",
    sparkleGold: "स्पार्कल गोल्ड",
    sparkleSilver: "स्पार्कल सिल्वर",
    sparkleCopper: "स्पार्कल कॉपर",
    size1x1: "1 फुट × 1 फुट",
    size1x15: "1 फुट × 1.5 फुट",
    size1x2: "1 फुट × 2 फुट",
    size2x1: "2 फुट × 1 फुट",
    size2x4: "2 फुट × 4 फुट",
  },
  careers: {
    eyebrow: "Ashlar Buildchem में करियर · जयपुर, भारत",
    h1a: "अपना करियर बनाएं",
    h1b: "प्रमाणित गुणवत्ता और",
    h1c: "विश्वास के साथ।",
    intro: "हम आधुनिक भारत के लिए उच्च प्रदर्शन वाले कंस्ट्रक्शन केमिकल्स, टाइल एडहेसिव और सतह समाधान तैयार करते हैं। एक ऐसी महत्वाकांक्षी टीम से जुड़ें जहाँ सटीक रसायन विज्ञान और विनिर्माण उत्कृष्टता का संगम होता है।",
    exploreOpenings: "उपलब्ध पद देखें",
    applyDirectly: "आवेदन जमा करें",
    whyJoin: "Ashlar क्यों चुनें",
    whyTitle: "उच्च मानक। वास्तविक रसायन। दीर्घकालिक प्रभाव।",
    p1Title: "केमिकल R&D और परीक्षण",
    p1Body: "हमारी अत्याधुनिक प्रयोगशाला में अत्याधुनिक पॉलिमर, सीमेंटिटियस एडहेसिव और तकनीकी मिश्रणों पर सीधे काम करें।",
    p2Title: "विनिर्माण उत्कृष्टता",
    p2Body: "सख्त ISO 9001:2015 और ISI मानकों के अनुसार निर्मित स्वचालित ड्राई-मिक्स उत्पादन लाइनों का अनुभव प्राप्त करें।",
    p3Title: "पूरे भारत में तीव्र विस्तार",
    p3Body: "जैसे-जैसे Ashlar वितरकों, ठेकेदारों और प्रमुख परियोजनाओं में विस्तार कर रहा है, अपने पेशेवर विकास को गति दें।",
    p4Title: "योग्यता और सत्यनिष्ठा सर्वोपरि",
    p4Body: "हम पहल, तकनीकी सटीकता और समर्पण को निष्पक्ष वेतन और नेतृत्व के अवसरों के साथ पुरस्कृत करते हैं।",
    openingsEyebrow: "वर्तमान रिक्तियां",
    openingsTitle: "विभिन्न टीमों में रिक्त पद।",
    allDepartments: "सभी विभाग",
    rdQuality: "R&D और गुणवत्ता",
    salesMarketing: "सेल्स और तकनीकी",
    operations: "प्लांट और संचालन",
    applyNow: "इस पद के लिए आवेदन करें",
    location: "स्थान",
    department: "विभाग",
    type: "प्रकार",
    experience: "अनुभव",
    urgentBadge: "तत्काल भर्ती",
    urgentHiringTitle: "तत्काल भर्ती: फील्ड सेल्स एग्जीक्यूटिव",
    urgentHiringSubtitle: "Ashlar Buildchem राजस्थान में अपने सेल्स नेटवर्क का विस्तार कर रहा है। तुरंत जॉइनिंग के लिए 3 पद उपलब्ध हैं।",
    preferredLocation: "पसंदीदा कार्य स्थान",
    selectLocation: "पसंदीदा स्थान चुनें",
    locJaipur: "जयपुर (1 पद)",
    locSikar: "सीकर (1 पद)",
    locDausa: "दौसा (1 पद)",
    locFlexible: "कोई भी / लचीला (जयपुर, सीकर, दौसा)",
    salaryLabel: "वेतन",
    salaryValue: "₹20,000 – ₹30,000 प्रति माह",
    fuelLabel: "ईंधन प्रतिपूर्ति",
    fuelValue: "केवल कंपनी के आधिकारिक कार्य हेतु पेट्रोल खर्च (घर से कार्यालय यात्रा शामिल नहीं)",
    candidatePreference: "बिल्डिंग मैटेरियल्स या कंस्ट्रक्शन केमिकल्स सेल्स में अनुभव रखने वाले उम्मीदवारों को प्राथमिकता। अच्छे संचार और सेल्स कौशल वाले फ्रेशर्स भी आवेदन कर सकते हैं।",
    vacanciesLabel: "रिक्तियां",
    formEyebrow: "नौकरी का आवेदन",
    formTitle: "अपना विवरण जमा करें",
    formSubtitle: "अपनी पृष्ठभूमि, अनुभव और अपनी रुचि वाले पद के बारे में बताएं। सभी आवेदनों पर हमारी भर्ती टीम सीधे विचार करती है।",
    fullName: "पूरा नाम",
    namePlaceholder: "उदा. राहुल शर्मा",
    email: "ईमेल पता",
    emailPlaceholder: "rahul@example.com",
    phone: "फ़ोन नंबर",
    roleApplied: "वांछित पद",
    selectRole: "पद चुनें",
    generalRole: "सामान्य / ओपन आवेदन",
    totalExperience: "कुल अनुभव",
    selectExperience: "अनुभव सीमा चुनें",
    expFresher: "फ्रेशर / शुरुआती स्तर",
    exp1to3: "1 - 3 वर्ष",
    exp3to5: "3 - 5 वर्ष",
    exp5plus: "5+ वर्ष",
    currentCompany: "वर्तमान कंपनी / कॉलेज",
    currentCompanyPlaceholder: "उदा. वर्तमान नियोक्ता या विश्वविद्यालय",
    noticePeriod: "नोटिस पीरियड",
    selectNotice: "नोटिस अवधि चुनें",
    noticeImmediate: "तुरंत शामिल हो सकते हैं",
    notice15: "15 दिन",
    notice30: "30 दिन",
    notice60: "60+ दिन",
    portfolioUrl: "रिज़्यूमे लिंक / लिंक्डइन URL",
    portfolioPlaceholder: "https://drive.google.com/... या linkedin.com/in/...",
    uploadResumeLabel: "रिज़्यूमे / CV दस्तावेज़",
    uploadResumeSubtext: ".pdf या .docx अपलोड करें (अधिकतम 10MB)",
    dragOrBrowse: "रिज़्यूमे चुनें या ड्रैग करें (.pdf या .docx, अधिकतम 10MB)",
    selectedFile: "चयनित दस्तावेज़",
    removeFile: "फ़ाइल हटाएं",
    orSwitchToUrl: "या लिंक्डइन प्रोफ़ाइल / ड्राइव लिंक दर्ज करें",
    orSwitchToFile: "दस्तावेज़ अपलोड पर वापस जाएं (.pdf / .docx)",
    fileReadyToUpload: "आवेदन जमा करते समय फ़ाइल अपलोड की जाएगी",
    fileSizeError: "फ़ाइल का आकार 10MB की सीमा से अधिक है। कृपया छोटी फ़ाइल चुनें।",
    fileTypeError: "केवल .pdf और .docx दस्तावेज़ ही स्वीकार किए जाते हैं।",
    statement: "कवर नोट / Ashlar क्यों?",
    statementPlaceholder: "अपनी सेल्स उपलब्धियों, बिल्डिंग मैटेरियल्स / कंस्ट्रक्शन केमिकल्स में अनुभव और Ashlar Buildchem से जुड़ने के कारणों के बारे में बताएं...",
    submitApplication: "आवेदन जमा करें",
    submitting: "आवेदन जमा हो रहा है…",
    uploadingAndSubmitting: "दस्तावेज़ अपलोड और जमा हो रहा है…",
    successMsg: "आपका आवेदन सफलतापूर्वक जमा हो गया है! हमारी HR टीम जल्द ही आपसे संपर्क करेगी।",
    errRequired: "कृपया सबमिट करने से पहले सभी आवश्यक फ़ील्ड भरें।",
    errName: "कृपया केवल मान्य नाम (अक्षर और स्पेस) दर्ज करें।",
    errPhone: "कृपया 10 अंकों का मान्य मोबाइल नंबर दर्ज करें।",
    errEmail: "कृपया एक मान्य ईमेल पता दर्ज करें।",
    hrHelp: "सीधा HR संपर्क",
    hrEmail: "hr@ashlarbuildchem.com",
    officeTitle: "मुख्यालय और प्रयोगशाला",
    processTitle: "हमारी भर्ती प्रक्रिया",
    step1: "01. आवेदन समीक्षा",
    step1Desc: "आपकी पृष्ठभूमि और तकनीकी प्रोफ़ाइल का विस्तृत मूल्यांकन।",
    step2: "02. तकनीकी चर्चा",
    step2Desc: "विभाग प्रमुखों के साथ व्यावहारिक तकनीकी राउंड।",
    step3: "03. प्लांट / कार्यालय दौरा",
    step3Desc: "हमारी सुविधा का भ्रमण और अपनी भावी टीम से मुलाकात।",
    step4: "04. प्रस्ताव और ऑनबोर्डिंग",
    step4Desc: "पारदर्शी प्रस्ताव और त्वरित ऑनबोर्डिंग सहायता।",
  },
  common: {
    loading: "लोड हो रहा है…",
  },
};

export default hi;
